export default __webpack_public_path__ + "images/graphics/kvd-test-black.png";